import { signal } from '@angular/core';
import { debounce, FieldTree, max, min, required, SchemaPathTree } from '@angular/forms/signals';
import { FactorsUDRDto } from '../../../../core/mceapi.client.generated';

export interface FactorsUdr {
  sustainedRating: number,
  referenceTemperature: number;
  parallelCables: number;
}

export function defaultFactorsUdr(): FactorsUdr {
  return {
    sustainedRating: 0,
    referenceTemperature: 20,
    parallelCables: 1
  };
}

export function buildFactorsUdrSchema(path: SchemaPathTree<FactorsUdr>) {

  required(path.sustainedRating, { message: `Sustained rating is required` });
  min(path.sustainedRating, 0, { message: `Sustained rating must be above 0 m` });
  debounce(path.sustainedRating, 500);

  required(path.referenceTemperature, { message: `Reference temperature is required` });
  min(path.referenceTemperature, -40, { message: `Reference temperature must be above -40 °C` });
  max(path.referenceTemperature, 120, { message: `Reference temperature must be below 120 °C` });
  debounce(path.referenceTemperature, 500);

  required(path.parallelCables, { message: `Parallel cables is required` });
  min(path.parallelCables, 1, { message: `Parallel cables must be positive` });
  debounce(path.parallelCables, 500);
}

export function createFactorsUdr(dto: FactorsUDRDto) {
  if (dto.sustainedRating === undefined || dto.referenceTemperature === undefined || dto.parallelCables === undefined) {
    throw new Error('User-defined rating factors DTO is missing required values.');
  }

  return signal<FactorsUdr>({
    sustainedRating: dto.sustainedRating,
    referenceTemperature: dto.referenceTemperature,
    parallelCables: dto.parallelCables,
  });
}

export function createFactorsUdrDto(model: FieldTree<FactorsUdr>) {
  return signal<FactorsUDRDto>({
    sustainedRating: model.sustainedRating().value(),
    referenceTemperature: model.referenceTemperature().value(),
    parallelCables: model.parallelCables().value(),
  });
}
